import React, { useState } from 'react';
import AdminSidebar from './components/AdminSidebar';
import Header from '../teacher_screen/components/Header';
import {
    Users,
    FilePlus,
    BarChart3,
    Upload,
    Clock,
    Plus,
    BookOpen,
    Search,
    MoreHorizontal,
    FileText,
    TrendingUp,
    Shield,
    Globe,
    ArrowUpRight
} from 'lucide-react';

const allCourses = [
    { id: 1, title: 'Mathematics - Class 10th A', teacher: 'Dr. Sarah Johnson', students: 42, engagement: 88, color: '#6366F1' },
    { id: 2, title: 'Advanced Physics - Class 11th B', teacher: 'Prof. Michael Chen', students: 35, engagement: 72, color: '#F59E0B' },
    { id: 3, title: 'English Literature - Class 9th C', teacher: 'Ms. Emily Blunt', students: 28, engagement: 91, color: '#10B981' },
    { id: 4, title: 'History of Art - Class 12th A', teacher: 'Mr. David Gandy', students: 45, engagement: 65, color: '#EC4899' },
];

export default function AdminLMS() {
    const stats = [
        { label: 'Total Content', value: '428', trend: '+12 this week', icon: Upload, color: 'text-blue-500 bg-blue-50' },
        { label: 'Active Learners', value: '1,240', trend: '98% activity', icon: Users, color: 'text-emerald-500 bg-emerald-50' },
        { label: 'Course Completion', value: '76%', trend: '+4% vs last month', icon: TrendingUp, color: 'text-amber-500 bg-amber-50' },
        { label: 'Storage Used', value: '12 GB', trend: 'Of 50 GB limit', icon: Shield, color: 'text-rose-500 bg-rose-50' },
    ];

    return (
        <div className="flex h-screen bg-[#F8FAFC] overflow-hidden font-sans">
            <AdminSidebar />

            <main className="flex-1 overflow-y-auto px-8">
                <Header
                    title="Institutional LMS"
                    subtitle="Centralized management of all course materials and learning analytics"
                >
                    <div className="flex items-center gap-3">
                        <div className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-100 rounded-xl text-xs font-black text-gray-500 shadow-sm">
                            <Globe size={14} className="text-blue-500" />
                            NETWORK STATUS: OPTIMAL
                        </div>
                    </div>
                </Header>

                <div className="max-w-7xl mx-auto">
                    {/* Admin Stats Grid */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
                        {stats.map((stat, idx) => (
                            <div key={idx} className="bg-white p-6 rounded-[32px] border border-gray-100 shadow-sm hover:scale-[1.02] transition-all cursor-default group">
                                <div className="flex items-center justify-between mb-4">
                                    <div className={`w-12 h-12 rounded-2xl flex items-center justify-center ${stat.color} group-hover:shadow-lg transition-all`}>
                                        <stat.icon size={22} strokeWidth={2.5} />
                                    </div>
                                    <div className="text-right">
                                        <span className="text-[11px] font-black text-gray-400 uppercase tracking-widest leading-none">{stat.label}</span>
                                        <h4 className="text-[28px] font-black text-[#111827] mt-1">{stat.value}</h4>
                                    </div>
                                </div>
                                <div className="flex items-center gap-1.5 text-[12px] font-bold text-[#111827] opacity-60">
                                    <ArrowUpRight size={14} className="text-emerald-500" />
                                    {stat.trend}
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Course Management Table */}
                    <div className="bg-white rounded-[40px] border border-gray-100 shadow-sm overflow-hidden mb-10">
                        <div className="p-8 border-b border-gray-50 flex items-center justify-between">
                            <div>
                                <h3 className="text-[20px] font-black text-[#111827] uppercase tracking-tighter">Institution Courses</h3>
                                <p className="text-gray-400 text-sm font-bold uppercase tracking-widest mt-1">Full spectrum course overview</p>
                            </div>
                            <div className="flex items-center gap-4">
                                <div className="relative">
                                    <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-300" size={18} />
                                    <input
                                        type="text"
                                        placeholder="Search courses..."
                                        className="h-12 pl-12 pr-6 bg-gray-50 border border-transparent rounded-2xl text-sm font-bold text-[#111827] focus:bg-white focus:border-blue-500 focus:outline-none transition-all w-64"
                                    />
                                </div>
                                <button className="p-3 bg-gray-50 text-gray-400 rounded-xl hover:bg-blue-50 hover:text-blue-500 transition-all">
                                    <Plus size={20} />
                                </button>
                            </div>
                        </div>

                        <div className="overflow-x-auto">
                            <table className="w-full text-left">
                                <thead>
                                    <tr className="bg-gray-50/50">
                                        <th className="px-8 py-5 text-[11px] font-black text-gray-400 uppercase tracking-widest">Course Title</th>
                                        <th className="px-8 py-5 text-[11px] font-black text-gray-400 uppercase tracking-widest">Lead Teacher</th>
                                        <th className="px-8 py-5 text-[11px] font-black text-gray-400 uppercase tracking-widest">Students</th>
                                        <th className="px-8 py-5 text-[11px] font-black text-gray-400 uppercase tracking-widest">Engagement</th>
                                        <th className="px-8 py-5 text-[11px] font-black text-gray-400 uppercase tracking-widest text-right">Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-50">
                                    {allCourses.map((course) => (
                                        <tr key={course.id} className="hover:bg-gray-50/50 transition-colors group">
                                            <td className="px-8 py-6">
                                                <div className="flex items-center gap-4">
                                                    <div className="w-10 h-10 rounded-xl flex items-center justify-center shrink-0" style={{ backgroundColor: `${course.color}15`, color: course.color }}>
                                                        <BookOpen size={20} />
                                                    </div>
                                                    <span className="text-[15px] font-black text-[#111827] uppercase tracking-tight">{course.title}</span>
                                                </div>
                                            </td>
                                            <td className="px-8 py-6">
                                                <div className="flex items-center gap-3">
                                                    <div className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center text-[10px] font-black text-gray-500">
                                                        {course.teacher.split(' ').map(n => n[0]).join('')}
                                                    </div>
                                                    <span className="text-[14px] font-bold text-gray-600">{course.teacher}</span>
                                                </div>
                                            </td>
                                            <td className="px-8 py-6">
                                                <span className="text-[14px] font-black text-[#111827]">{course.students}</span>
                                            </td>
                                            <td className="px-8 py-6">
                                                <div className="flex items-center gap-3">
                                                    <div className="flex-1 h-1.5 w-24 bg-gray-100 rounded-full overflow-hidden">
                                                        <div className="h-full rounded-full transition-all duration-1000" style={{ width: `${course.engagement}%`, backgroundColor: course.color }} />
                                                    </div>
                                                    <span className="text-[12px] font-bold text-gray-400">{course.engagement}%</span>
                                                </div>
                                            </td>
                                            <td className="px-8 py-6 text-right">
                                                <button className="p-2 text-gray-300 hover:text-blue-500 hover:bg-blue-50 rounded-lg transition-all">
                                                    <MoreHorizontal size={20} />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="p-8 bg-gray-50/30 flex justify-center border-t border-gray-50">
                            <button className="text-[12px] font-black text-blue-500 uppercase tracking-widest hover:underline">View Comprehensive Network Analytics</button>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}
